import { httpWithAuth } from '~/clients';
import ClientId from '~/constants/ClientId';
import { OPEN_PERSONALIZED_RECS } from '~/constants/endpoints';
import type { RecommendedVehicle } from '~/contracts/common';
import { BrowserCookies } from '~/utilities';

type SuggestedVehiclesRequest = {
  zipCode: string;
};

type VehicleFromRecommendations = Omit<
  RecommendedVehicle,
  'isFavorited' | 'vehicleUnlockDateTime'
> & {
  imageUrl?: string;
  vehicleUnlockDateTime: string;
};

export default async function fetchSuggestedVehicles(
  { zipCode }: SuggestedVehiclesRequest,
  controller: AbortController
): Promise<RecommendedVehicle[]> {
  const data = await httpWithAuth.post(
    OPEN_PERSONALIZED_RECS,
    {
      pagination: {
        page: 1,
        pageSize: 12
      },
      zip5: zipCode,
      clientId: ClientId.HOME_UI,
      browserCookieId: BrowserCookies.get('BrowserCookieId')
    },
    {
      signal: controller.signal
    }
  );

  return data.data.vehicles.map(
    (vehicle: VehicleFromRecommendations): RecommendedVehicle => ({
      ...vehicle,
      isFavorited: false
    })
  );
}
